import { store } from ".."
import api from "../../providers/api"
import history from "../../providers/history"
import { GetObject } from "../../providers/storage"
import { IAuthenticatedUser } from "../authentication/types"
import { fileUploadSetPercentage } from "./slices"

// *** LIST PHOTOS *** 
export const roomVideosListRequestService = (roomId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.get(`rooms/${roomId}/videos?type=videos`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}
// *** DELETE VIDEO *** 
export const roomVideoDeleteRequestService = (videoId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.delete(`rooms/videos/${videoId}`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}

// *** BLOB *** 
export const fileDownloadService = (link: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.get(link, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        },
        responseType: 'blob'
    })
}

// *** UPLOAD ***
export const fileUploadService = (id: string, data: FormData) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.post('uploads/', data, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        },
        onUploadProgress: (event) => {
            let progress: number = Math.round(
                (event.loaded * 100) / event.total
            );

            store.dispatch(fileUploadSetPercentage({
                id,
                percentage: progress
            }))
        },
    })
}
//UPLOAD ROOM PHOTOS
export const roomVideoSaveRequestService = (roomId: string, path: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.put(`rooms/videos/${roomId}/${path}`, null,
        {
            headers: {
                Authorization: `Bearer ${authenticatedUser.token}`
            }
        })
}